import { OverlayPosition } from '../../../../../../ui/gzInfoOverlay/type';
import { MspInProductTrialsOverlayWindowType } from '../../types/MspInProductTrialsOverlayWindowType';
import { GzInfoOverlayWebComponent } from '../../../../../../ui/gzInfoOverlay';

export enum MenuItem {
  Company = 'companies',
}

export enum MenuState {
  Hidden = 1,
  Collapsed = 2,
  Expanded = 3,
}

export enum MspInProductTrialsOverlayState {
  SoftDismissed = 0,
  OverlayDisplayedWithCheckbox = 1,
  CompletelyDismissed = 2,
}

export function getTargetForMenuStateByMenuItem(menuState: MenuState): {
  [menuItem in MenuItem]: string;
} {
  const menuItemPrefix = 'menu_item_';
  const menuItemSuffix = '_parent';

  return {
    [MenuItem.Company]:
      menuState === MenuState.Collapsed
        ? menuItemPrefix + MenuItem.Company + menuItemSuffix
        : menuItemPrefix + MenuItem.Company,
  };
}

function getInProductTrialsOverlayWindowConfig(menuState: MenuState): {
  [type in MspInProductTrialsOverlayWindowType]: { position: OverlayPosition };
} {
  const menuOverlay = {
    position: OverlayPosition.LEFT_BOTTOM,
  };
  const firstCompany = {
    position: OverlayPosition.LEFT_TOP,
  };

  return {
    [MspInProductTrialsOverlayWindowType.menuOverlay]: menuOverlay,
    [MspInProductTrialsOverlayWindowType.companiesOverlay]: firstCompany,
  };
}

export function getMspInProductTrialsOverlayWindowConfigByWindowType(
  overlayWindowType: MspInProductTrialsOverlayWindowType,
  menuState: MenuState
): { position: OverlayPosition } {
  return getInProductTrialsOverlayWindowConfig(menuState)[overlayWindowType];
}

export interface MspInProductTrialsAdditionalUserSettings {
  mspInProductTrialsOverlayState: number | undefined;
}

export interface MspInProductTrialsOverlayWindowDetails {
  type: MspInProductTrialsOverlayWindowType;
  component?: GzInfoOverlayWebComponent;
}
